module.exports = __webpack_public_path__ + "files/d45c85a1b699c5b615e12fea526abe22.png";


/*****************
 ** WEBPACK FOOTER
 ** ./images/themes/organization.png
 ** module id = 826
 ** module chunks = 0
 **/